import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import algoliaSearch from 'algoliasearch/lite';
import { Configure } from 'react-instantsearch-core';
import { InstantSearch } from 'react-instantsearch-dom';
export { InstantSearch } from 'react-instantsearch-dom';
import { findResultsState } from 'react-instantsearch-dom/server';
import { useAlgoliaConfig } from './AlgoliaConfig.js';
import { AlgoliaConfigProvider } from './AlgoliaConfigProvider.js';
import AlgoliaDataProvider from './AlgoliaDataProvider.js';
import VirtualFacets from './components/VirtualFacets/VirtualFacets.js';
import { parseCommercialFacets } from './utils/parse-commercial-facets.js';

const AlgoliaSearch = ({ children  })=>{
    const { algoliaInstantSearchProps , facetingAfterDistinct  } = useAlgoliaConfig();
    return /*#__PURE__*/ React.createElement(InstantSearch, swcHelpers.extends({}, algoliaInstantSearchProps), /*#__PURE__*/ React.createElement(VirtualFacets, null), /*#__PURE__*/ React.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), /*#__PURE__*/ React.createElement(AlgoliaDataProvider, null, children));
};
function fetchAlgoliaConfig(props) {
    return _fetchAlgoliaConfig.apply(this, arguments);
}
function _fetchAlgoliaConfig() {
    _fetchAlgoliaConfig = swcHelpers.asyncToGenerator(function*(props) {
        if (!props.isEnabled) {
            return props;
        }
        const { appId , apiKey  } = props.options;
        const searchClient = algoliaSearch(appId, apiKey);
        try {
            const index = searchClient.initIndex(props.options.indexName);
            /**
     * Algolia SDK does not easily expose all the facets in the resultsState, so we have to
     * manually fetch all the facets and integrate them to the existing ones coming from next.config.
     * The alternative is to get from rawResults (https://github.com/algolia/instantsearch/issues/6202)
     * but since we need to have access to all facets before we SSR, we need to fetch all the facets here:
     */ const prefetchFacetsResult = yield index.search('', {
                facets: [
                    '*'
                ]
            });
            const commercialFacets = parseCommercialFacets({
                rawFacets: prefetchFacetsResult.facets
            });
            const combinedProps = swcHelpers.objectSpread({}, props, {
                options: swcHelpers.objectSpread({}, props.options, {
                    facets: [
                        ...props.options.facets,
                        ...commercialFacets
                    ]
                })
            });
            return swcHelpers.objectSpread({}, combinedProps, {
                resultsState: yield findResultsState((providedProps)=>{
                    return /*#__PURE__*/ React.createElement(AlgoliaConfigProvider, swcHelpers.extends({}, combinedProps), /*#__PURE__*/ React.createElement(InstantSearchContainer, swcHelpers.extends({}, providedProps), /*#__PURE__*/ React.createElement(VirtualFacets, null)));
                }, swcHelpers.objectSpread({
                    searchClient
                }, combinedProps.options))
            });
        } catch (err) {
            console.log('An error occured while fetching algolia hits');
            console.error(err);
            return swcHelpers.objectSpread({}, props, {
                isEnabled: false
            });
        }
    });
    return _fetchAlgoliaConfig.apply(this, arguments);
}
const InstantSearchContainer = (props)=>{
    const { algoliaInstantSearchProps  } = useAlgoliaConfig();
    return /*#__PURE__*/ React.createElement(InstantSearch, swcHelpers.extends({}, algoliaInstantSearchProps, props), props.children);
};

export { AlgoliaSearch, fetchAlgoliaConfig };
//# sourceMappingURL=AlgoliaSearch.js.map
